document.addEventListener('DOMContentLoaded', () => {
  const markInteraction = () => {
    sessionStorage.setItem('user_interacted', '1');
    document.removeEventListener('click', markInteraction);
    document.removeEventListener('touchstart', markInteraction);
  };
  document.addEventListener('click', markInteraction, { once: true });
  document.addEventListener('touchstart', markInteraction, { once: true });

  const ensureParam = (url, key, val) => {
    const u = new URL(url, window.location.origin);
    if (!u.searchParams.has(key)) u.searchParams.set(key, val);
    return u.toString();
  };

  const prepareIframeSrc = (iframe) => {
    try {
      const src = iframe.getAttribute('src') || '';
      if (!src) return;
      if (src.includes('youtube.com') || src.includes('youtu.be')) {
        let newSrc = ensureParam(src, 'enablejsapi', '1');
        newSrc = ensureParam(newSrc, 'playsinline', '1');
        newSrc = ensureParam(newSrc, 'rel', '0');
        if (newSrc !== src) iframe.setAttribute('src', newSrc);
      } else if (src.includes('player.vimeo.com')) {
        let newSrc = ensureParam(src, 'api', '1');
        newSrc = ensureParam(newSrc, 'background', '0');
        if (newSrc !== src) iframe.setAttribute('src', newSrc);
      }
    } catch (e) {}
  };

  const postYTPlayUnmute = (iframe) => {
    iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'unMute' }), '*');
    iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*');
  };

  const postVimeoPlayUnmute = (iframe) => {
    iframe.contentWindow?.postMessage({ method: 'setVolume', value: 1 }, '*');
    iframe.contentWindow?.postMessage({ method: 'play' }, '*');
  };

  const addUnmuteOverlay = (el) => {
    if (el.dataset.unmuteReady === '1') return;
    el.dataset.unmuteReady = '1';
    const overlay = document.createElement('div');
    overlay.className = 'unmute-wrapper';
    const btn = document.createElement('button');
    btn.className = 'unmute-btn';
    btn.textContent = 'Tap to Play with Sound';
    overlay.appendChild(btn);
    const container = el.parentElement;
    if (container && getComputedStyle(container).position === 'static') container.style.position = 'relative';
    (container || el).appendChild(overlay);
    const tryPlay = async () => {
      if (el.tagName.toLowerCase() === 'video') {
        try {
          el.muted = false;
          el.setAttribute('playsinline', '');
          el.setAttribute('webkit-playsinline', '');
          if (el.paused) await el.play();
          overlay.remove();
        } catch {}
        return;
      }
      if (el.tagName.toLowerCase() === 'iframe') {
        const src = el.getAttribute('src') || '';
        if (/youtube\.com|youtu\.be/.test(src)) {
          postYTPlayUnmute(el);
        } else if (/vimeo\.com/.test(src)) {
          postVimeoPlayUnmute(el);
        }
        overlay.remove();
      }
    };
    if (sessionStorage.getItem('user_interacted')) setTimeout(tryPlay, 60);
    btn.addEventListener('click', tryPlay);
  };

  const initMediaIn = (root = document) => {
    root.querySelectorAll('video, iframe').forEach((m) => {
      if (m.tagName.toLowerCase() === 'iframe') prepareIframeSrc(m);
      m.controls = true;
      addUnmuteOverlay(m);
    });
  };

  initMediaIn();

  if (window.customElements?.whenDefined) {
    customElements.whenDefined('deferred-media').then(() => {
      document.querySelectorAll('deferred-media').forEach((dm) => {
        dm.addEventListener('click', () => setTimeout(() => initMediaIn(dm), 80));
      });
    });
  }

  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) initMediaIn(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
});
